import React, {useEffect, useState} from 'react';
import {DatePicker} from "antd";
import { each, groupBy } from '@antv/util';

import {Column} from "@ant-design/plots";

import {API_PATH} from "../../components/const";
import moment from "moment/moment";
import dayjs from "dayjs";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import * as XLSX from "xlsx";
const {RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';


const DailyAnalytics = () => {
    const [time, setTime] = useState(new Date());
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false)


    const moment = require('moment')

    const asyncFetch = () => {
        console.log()
        // fetch(API_PATH + "company/" + localStorage.getItem('id') + "/analitics/age?date_str=" + time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" +  Number(time?.getDate()) , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
        fetch(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/visitor-demographics/age-sex-distribution?start_date_str="+ time?.getFullYear() + "-" + Number(time?.getMonth() + 1) + "-" + 1 + "&end_date_str=" + moment().endOf('month').format('YYYY-MM-DD') , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then((response) => response.json())
            .then((json) => setData(json?.map(item  =>{
                return {
                    ...item,
                    type: item?.type === "male" ? "Мужской" : "Женский",
                }
            })))
            .catch((error) => {
            });
    };
    function onChange(date, dateString) {
        if (dateString?.length > 0) {
            fetch(API_PATH + "company/" + localStorage.getItem('id') + "/analytics/visitor-demographics/age-sex-distribution?start_date_str=" + dateString[0] + "&end_date_str=" + dateString[1], {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
                .then((response) => response.json())
                .then((json) => setData(json?.map(item  => {
                    return {
                        ...item,
                        type: item?.type === "male" ? "Мужской" : "Женский",
                    }
                })))
                .catch((error) => {
                    // console.log('fetch data failed', error);
                });
        } else (
            asyncFetch()
        )
    }


    const annotations = [];
    each(groupBy(data, 'age_range'), (values, k) => {
        const value = values.reduce((a, b) => a + b.value, 0);
        annotations.push({
            type: 'text',
            position: [k, value],
            content: `${value}`,
            style: {
                textAlign: 'center',
                fontSize: 14,
                fill: '#FFFFFF',

            },
            offsetY: -15,
        });
    });
    const config = {
        data,
        isStack: true,
        xField: 'age_range',
        yField: 'value',
        seriesField: 'type',
        color:[ '#FC53F5','#5664D2', '#00E480', '#FF3542', '#0090EB', '#FFB100', '#4D4F6C'],

        xAxis: {
            label: {
                style: {
                    fill: "#fff",
                },
            },
        },
        yAxis: {
            count: {
                label: {
                    style: {
                        fill: "#fff",
                    },
                },
            },
            value: {
                label: {
                    style: {
                        fill: "#fff",
                    },
                },
            },
        },
        style: {fill: '#fff'},
        geometryOptions: [
            {
                geometry: "line",
                color: ["#fff", "#fff"],
                seriesField: "type",
            },
            {
                geometry: "line",
                color: "#fff",
                seriesField: "type",
            },
        ],
        label: {
            position: 'middle',
            style: {
                fontSize: 14,
                textAlign: 'center',
            },
            layout: [
                {
                    type: 'interval-adjust-position',
                },
                {
                    type: 'interval-hide-overlap',
                },
                {
                    type: 'adjust-color',
                },
            ],
        },
        annotations,
    };


    const processDataForTable = (data) => {
        const groupedData = {};

        // Har bir yosh oralig‘i uchun 0 bilan boshlang‘ich obyekt yaratamiz
        data.forEach(({ age_range, type, value }) => {
            if (!groupedData[age_range]) {
                groupedData[age_range] = {
                    "Yosh Oralig‘i": age_range,
                    "Erkaklar": 0,
                    "Ayollar": 0
                };
            }

            // Erkak yoki ayol ekanligini tekshirib, tegishli joyga qiymat qo‘shamiz
            if (type === "Мужской") {
                groupedData[age_range]["Erkaklar"] = value;
            } else if (type === "Женский") {
                groupedData[age_range]["Ayollar"] = value;
            }
        });

        // Natijani massivga o‘tkazamiz va yosh oralig‘ini o‘sish tartibida saralaymiz
        return Object.values(groupedData).sort((a, b) => {
            const [aStart] = a["Yosh Oralig‘i"].split("-").map(Number);
            const [bStart] = b["Yosh Oralig‘i"].split("-").map(Number);
            return aStart - bStart;
        });
    };

    const exportToExcel = () => {

        const formattedData = processDataForTable(data);
        if (formattedData.length === 0) {
            return;
        }

        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "AgeRangeData");
        XLSX.writeFile(workbook, "age_range_data.xlsx");
    };


    const [sortedData, setSortedData] = useState([]);



    useEffect(() => {
        setSortedData(processDataForTable(data)); // Data kelganda saralash
    }, [data]);
    const sortTable = () => {
        const sorted = [...sortedData].sort((a, b) => {
            const [aStart] = a["Yosh Oralig‘i"].split("-").map(Number);
            const [bStart] = b["Yosh Oralig‘i"].split("-").map(Number);
            return aStart - bStart;
        });
        setSortedData(sorted);
    };
    useEffect(() => {
        asyncFetch()

    }, []);
    return (
        <div className="visitor visitor-box ">
            <div className="chart-box">
                <div className="visitor-title">
                    <h1><span>
                    Ежедневная аналитика по возрастам
                </span>
                       <RangePicker
                                placeholder={["Дата начала", "Дата окончания"]}
                            defaultValue={[dayjs(moment().startOf('month').format('YYYY-MM-DD'), dateFormat), dayjs(moment().endOf('month').format('YYYY-MM-DD'), dateFormat)]}

                            format={dateFormat}
                            onChange={onChange}
                        />

                        {/*<DatePicker onChange={onChange} />*/}
                    </h1>
                </div>
                <Column {...config} />

                {
                    data?.length > 0
                        ?
                        <div className="emp-table mt-4 ">
                            <div className="d-flex justify-content-between">
                                <button type="submit" className="add-btn mb-3" onClick={() => setShow(!show)}>Посмотреть таблицу</button>
                                <button type="submit" className="btn btn-success mb-3" onClick={exportToExcel}>Скачать таблицу</button>
                            </div>
                            {
                                show
                                    ?
                                    <TableContainer component={Paper}>
                                        <Table sx={{minWidth: 650}} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className="  table-head">По возрастам</TableCell>
                                                    <TableCell className="table-head" >Мужчины</TableCell>
                                                    <TableCell className="table-head" >Женщины</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {sortedData.map((item, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell className="text-white">{item["Yosh Oralig‘i"]}</TableCell>
                                                        <TableCell className="text-white">{item["Erkaklar"]}</TableCell>
                                                        <TableCell className="text-white">{item["Ayollar"]}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    :
                                    ""
                            }

                        </div>
                        :
                        ""
                }


            </div>
        </div>
    );
};

export default DailyAnalytics;